import { toast } from "react-toastify";

/**
 * Universal API response handler for your backend pattern.
 * It checks errorCode and shows toast notifications.
 *
 * @param {object} response - API response object from backend
 * @param {string} successMessage - Optional custom success message override
 * @returns {object|null} - Returns responseData on success, or null on failure
 */
export function handleApiResponse(response, successMessage = null) {
  if (!response) {
    toast.error("No response from server.");
    return null;
  }

  if (response.errorCode) {
    toast.error(response.responseMessage || "Operation failed.");
    return null;
  }

  // Only show a success toast if a success message exists
  if (successMessage) {
    toast.success(successMessage || response.responseMessage || "Operation successful.");
  }

  return response.responseData || null;
}
